import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { Spin, Layout } from 'antd';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { getAssetIcon } from 'assets/containers/AssetDetailView/styles';

const MapStyle = {
  marginBottom: '8px',
  height: '180px',
  width: '188px',
  borderRadius: '0px',
};

function getMapIcon(category) {
  return L.icon({
    iconUrl: getAssetIcon(category),
    iconSize: [50, 60],
  });
}

const MiniMap = ({ location, category }) => {
  if (!location.latitude || !location.longitude) {
    return (
      <Layout>
        <Spin size={'small'} />
      </Layout>
    );
  }
  return (
    <MapContainer
      key={location.longitude + location.latitude}
      center={[location.latitude, location.longitude]}
      zoom={13}
      scrollWheelZoom={false}
      zoomControl={false}
      style={MapStyle}
    >
      <TileLayer url="https://api.mapbox.com/styles/v1/stormpulse/ck0zgcsyw0yrc1ckypuh2q4be/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic3Rvcm1wdWxzZSIsImEiOiJYd1YxUXpNIn0.N_-0IOIF6RUOHyF9JUIPVQ" />
      <Marker position={[location.latitude, location.longitude]} icon={getMapIcon(category)} />
    </MapContainer>
  );
};

export default MiniMap;
